// const port = "http://localhost:8001"
const port = "https://api.5stargrading.com"

export default port;